export enum PICKUP_STORE_CONST {
  TEST_ID = 'pickup-store',
}

export type PickupStoreConfig = {
  title: string;
};

export type PickupStoreProps = PickupStoreConfig;
